import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export interface PolicyDetailsForm {
  name: string;
  description: string;
  class: Array<string>;
  event: Array<string>;
}

export const updatePolicyAPI = async (
  policyId: string,
  policyDetails: PolicyDetailsForm,
) => {
  const resp = await baseAPI.patch<unknown>(
    `/policies/${policyId}`,
    policyDetails,
  );
  return resp.data;
};

export const useUpdatePolicyMutation = () => {
  return useMutation({
    mutationFn: async (params: {
      policyId: string;
      policyDetails: PolicyDetailsForm;
    }) => {
      const response = await updatePolicyAPI(
        params.policyId,
        params.policyDetails,
      );
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.POLICIES],
      });
    },
  });
};
